"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeBlockCardStrategy = exports.themeNoCardStrategy = exports.themeStrategy = exports.ThemeNoCardVariantsArray = exports.ThemeBlockVariantsArray = exports.ThemeCardVariantsArray = exports.ThemeVariantsArray = exports.ThemeNoCardVariants = exports.ThemeBlockVariants = exports.ThemeCardVariants = exports.ThemeVariants = exports.ThemeSize = exports.ThemeType = void 0;

var _themeStrategy, _themeNoCardStrategy, _themeBlockCardStrate;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ThemeType;
exports.ThemeType = ThemeType;

(function (ThemeType) {
  ThemeType["DARK"] = "dark";
  ThemeType["LIGHT"] = "light";
})(ThemeType || (exports.ThemeType = ThemeType = {}));

var ThemeSize;
exports.ThemeSize = ThemeSize;

(function (ThemeSize) {
  ThemeSize["FULL"] = "full";
  ThemeSize["HALF"] = "half";
  ThemeSize["CROPPED"] = "cropped";
  ThemeSize["TRANSPARENT"] = "transparent";
})(ThemeSize || (exports.ThemeSize = ThemeSize = {}));

var ThemeVariants;
exports.ThemeVariants = ThemeVariants;

(function (ThemeVariants) {
  ThemeVariants["WHITE"] = "white";
  ThemeVariants["SEASHELL"] = "seashell";
  ThemeVariants["SEASHELL_ALT"] = "seashell-alt";
  ThemeVariants["SEASHELL_CROPPED"] = "seashell-cropped";
  ThemeVariants["MOCASSIN"] = "mocassin";
  ThemeVariants["MOCASSIN_ALT"] = "mocassin-alt";
  ThemeVariants["MOCASSIN_CROPPED"] = "mocassin-cropped";
  ThemeVariants["CLARET"] = "claret";
  ThemeVariants["CLARET_ALT"] = "claret-alt";
  ThemeVariants["CLARET_CROPPED"] = "claret-cropped";
  ThemeVariants["BLACK"] = "black";
  ThemeVariants["BLACK_ALT"] = "black-alt";
  ThemeVariants["BLACK_CROPPED"] = "black-cropped";
  ThemeVariants["IMAGE_DARK"] = "image-dark";
  ThemeVariants["IMAGE_LIGHT"] = "image-light";
  ThemeVariants["GEM"] = "gem";
})(ThemeVariants || (exports.ThemeVariants = ThemeVariants = {}));

var ThemeCardVariants;
exports.ThemeCardVariants = ThemeCardVariants;

(function (ThemeCardVariants) {
  ThemeCardVariants["WHITE"] = "white";
  ThemeCardVariants["SEASHELL"] = "seashell";
  ThemeCardVariants["SEASHELL_CARD"] = "seashell-card";
  ThemeCardVariants["MOCASSIN"] = "mocassin";
  ThemeCardVariants["MOCASSIN_CARD"] = "mocassin-card";
  ThemeCardVariants["CLARET"] = "claret";
  ThemeCardVariants["CLARET_CARD"] = "claret-card";
  ThemeCardVariants["BLACK"] = "black";
  ThemeCardVariants["BLACK_CARD"] = "black-card";
})(ThemeCardVariants || (exports.ThemeCardVariants = ThemeCardVariants = {}));

var ThemeBlockVariants;
exports.ThemeBlockVariants = ThemeBlockVariants;

(function (ThemeBlockVariants) {
  ThemeBlockVariants["WHITE"] = "white";
  ThemeBlockVariants["SEASHELL"] = "seashell";
  ThemeBlockVariants["SEASHELL_BLOCK"] = "seashell-block";
  ThemeBlockVariants["MOCASSIN"] = "mocassin";
  ThemeBlockVariants["MOCASSIN_BLOCK"] = "mocassin-block";
  ThemeBlockVariants["CLARET"] = "claret";
  ThemeBlockVariants["CLARET_BLOCK"] = "claret-block";
  ThemeBlockVariants["BLACK"] = "black";
  ThemeBlockVariants["BLACK_BLOCK"] = "black-block";
})(ThemeBlockVariants || (exports.ThemeBlockVariants = ThemeBlockVariants = {}));

var ThemeNoCardVariants;
exports.ThemeNoCardVariants = ThemeNoCardVariants;

(function (ThemeNoCardVariants) {
  ThemeNoCardVariants["WHITE"] = "white";
  ThemeNoCardVariants["SEASHELL"] = "seashell";
  ThemeNoCardVariants["SEASHELL_NO_CARD"] = "seashell-no-card";
  ThemeNoCardVariants["MOCASSIN"] = "mocassin";
  ThemeNoCardVariants["MOCASSIN_NO_CARD"] = "mocassin-no-card";
  ThemeNoCardVariants["CLARET"] = "claret";
  ThemeNoCardVariants["CLARET_NO_CARD"] = "claret-no-card";
  ThemeNoCardVariants["BLACK"] = "black";
  ThemeNoCardVariants["BLACK_NO_CARD"] = "black-no-card";
})(ThemeNoCardVariants || (exports.ThemeNoCardVariants = ThemeNoCardVariants = {}));

var ThemeVariantsArray = Object.values(ThemeVariants);
exports.ThemeVariantsArray = ThemeVariantsArray;
var ThemeCardVariantsArray = Object.values(ThemeCardVariants);
exports.ThemeCardVariantsArray = ThemeCardVariantsArray;
var ThemeBlockVariantsArray = Object.values(ThemeBlockVariants);
exports.ThemeBlockVariantsArray = ThemeBlockVariantsArray;
var ThemeNoCardVariantsArray = Object.values(ThemeNoCardVariants);
exports.ThemeNoCardVariantsArray = ThemeNoCardVariantsArray;
var themeStrategy = (_themeStrategy = {}, _defineProperty(_themeStrategy, ThemeVariants.WHITE, {
  type: ThemeType.LIGHT,
  size: ThemeSize.FULL,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.SEASHELL, {
  type: ThemeType.LIGHT,
  size: ThemeSize.FULL,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.SEASHELL_ALT, {
  type: ThemeType.LIGHT,
  size: ThemeSize.HALF,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.SEASHELL_CROPPED, {
  type: ThemeType.LIGHT,
  size: ThemeSize.CROPPED,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.MOCASSIN, {
  type: ThemeType.LIGHT,
  size: ThemeSize.FULL,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.MOCASSIN_ALT, {
  type: ThemeType.LIGHT,
  size: ThemeSize.HALF,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.MOCASSIN_CROPPED, {
  type: ThemeType.LIGHT,
  size: ThemeSize.CROPPED,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.CLARET, {
  type: ThemeType.DARK,
  size: ThemeSize.FULL,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeStrategy, ThemeVariants.CLARET_ALT, {
  type: ThemeType.DARK,
  size: ThemeSize.HALF,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeStrategy, ThemeVariants.CLARET_CROPPED, {
  type: ThemeType.DARK,
  size: ThemeSize.CROPPED,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.BLACK, {
  type: ThemeType.DARK,
  size: ThemeSize.FULL,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeStrategy, ThemeVariants.BLACK_ALT, {
  type: ThemeType.DARK,
  size: ThemeSize.HALF,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeStrategy, ThemeVariants.BLACK_CROPPED, {
  type: ThemeType.DARK,
  size: ThemeSize.CROPPED,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.GEM, {
  type: ThemeType.DARK,
  size: ThemeSize.FULL,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeStrategy, ThemeVariants.IMAGE_LIGHT, {
  type: ThemeType.LIGHT,
  size: ThemeSize.TRANSPARENT,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeStrategy, ThemeVariants.IMAGE_DARK, {
  type: ThemeType.DARK,
  size: ThemeSize.TRANSPARENT,
  headline1Color: 'white',
  headline2Color: 'white'
}), _themeStrategy);
exports.themeStrategy = themeStrategy;
var themeNoCardStrategy = (_themeNoCardStrategy = {}, _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.WHITE, {
  type: ThemeType.LIGHT,
  isCardsTransparent: true,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.SEASHELL, {
  type: ThemeType.LIGHT,
  isCardsTransparent: false,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.SEASHELL_NO_CARD, {
  type: ThemeType.LIGHT,
  isCardsTransparent: true,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.MOCASSIN, {
  type: ThemeType.LIGHT,
  isCardsTransparent: false,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.MOCASSIN_NO_CARD, {
  type: ThemeType.LIGHT,
  isCardsTransparent: true,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.CLARET, {
  type: ThemeType.DARK,
  isCardsTransparent: false,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.CLARET_NO_CARD, {
  type: ThemeType.DARK,
  isCardsTransparent: true,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.BLACK, {
  type: ThemeType.DARK,
  isCardsTransparent: false,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_themeNoCardStrategy, ThemeNoCardVariants.BLACK_NO_CARD, {
  type: ThemeType.DARK,
  isCardsTransparent: true,
  headline1Color: 'white',
  headline2Color: 'white'
}), _themeNoCardStrategy);
exports.themeNoCardStrategy = themeNoCardStrategy;
var themeBlockCardStrategy = (_themeBlockCardStrate = {}, _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.WHITE, {
  type: ThemeType.LIGHT,
  isBlock: false
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.SEASHELL, {
  type: ThemeType.LIGHT,
  isBlock: false
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.SEASHELL_BLOCK, {
  type: ThemeType.LIGHT,
  isBlock: true
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.MOCASSIN, {
  type: ThemeType.LIGHT,
  isBlock: false
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.MOCASSIN_BLOCK, {
  type: ThemeType.LIGHT,
  isBlock: true
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.CLARET, {
  type: ThemeType.DARK,
  isBlock: false
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.CLARET_BLOCK, {
  type: ThemeType.DARK,
  isBlock: true
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.BLACK, {
  type: ThemeType.DARK,
  isBlock: false
}), _defineProperty(_themeBlockCardStrate, ThemeBlockVariants.BLACK_BLOCK, {
  type: ThemeType.DARK,
  isBlock: true
}), _themeBlockCardStrate);
exports.themeBlockCardStrategy = themeBlockCardStrategy;